import { Component, OnInit, AfterViewInit, Renderer, ElementRef } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';

import { PasswordResetFinish } from './password-reset-finish.service';
import { LoginModalService } from '../../../shared';
import { PASSWORD_INPUT_CLASS } from '../../../shared/constants/password.constants';

@Component({
    selector: 'jhi-password-reset-finish',
    templateUrl: './password-reset-finish.component.html'
})
export class PasswordResetFinishComponent implements OnInit, AfterViewInit {
    confirmPassword: string;
    doNotMatch: string;
    error: string;
    keyMissing: boolean;
    resetAccount: any;
    success: string;
    modalRef: NgbModalRef;
    key: string;
    showPassword: boolean;
    passwordInputClass: string;
    showConfirmPassword: boolean;
    confirmPasswordInputClass: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private passwordResetFinish: PasswordResetFinish,
        private loginModalService: LoginModalService,
        private route: ActivatedRoute,
        private elementRef: ElementRef, private renderer: Renderer
    ) {
        this.jhiLanguageService.setLocations(['reset']);
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.key = params['key'];
        });
        this.resetAccount = {};
        this.keyMissing = !this.key;

        this.showPassword = false;
        this.passwordInputClass = PASSWORD_INPUT_CLASS.HIDE;
        this.showConfirmPassword = false;
        this.confirmPasswordInputClass = PASSWORD_INPUT_CLASS.HIDE;
    }

    ngAfterViewInit() {
        if (this.elementRef.nativeElement.querySelector('#password') != null) {
            this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#password'), 'focus', []);
        }
    }

    toggleShowPassword(event: MouseEvent) {
        this.showPassword = !this.showPassword;
        this.passwordInputClass = this.showPassword ? PASSWORD_INPUT_CLASS.SHOW : PASSWORD_INPUT_CLASS.HIDE;

        // this is to not launch login upon click
        event.preventDefault();
    }

    toggleShowConfirmPassword(event: MouseEvent) {
        this.showConfirmPassword = !this.showConfirmPassword;
        this.confirmPasswordInputClass = this.showConfirmPassword ? PASSWORD_INPUT_CLASS.SHOW : PASSWORD_INPUT_CLASS.HIDE;

        // this is to not launch login upon click
        event.preventDefault();
    }

    onKeyDown(event: KeyboardEvent): void {
        // this is to toggle show text upon enter key but do login
         if (event.key === 'Enter') {
          event.preventDefault();
        }
    }

    finishReset() {
        this.doNotMatch = null;
        this.error = null;
        if (this.resetAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        } else {
            this.passwordResetFinish.save({ key: this.key, newPassword: this.resetAccount.password }).subscribe(() => {
                this.success = 'OK';
            }, () => {
                this.success = null;
                this.error = 'ERROR';
            });
        }
    }

    login() {
        this.modalRef = this.loginModalService.open();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/finish/password-reset-finish.component.ts